import relationshipRoles from './relationshipRoles';
// 👆 FIRST: Define this BEFORE buildContext

const extractEntities = (message = '') => {
  const entities = [];
  message = message.replace(/[‘’]/g, "'").replace(/[“”]/g, '"');

  const cleaned = message.toLowerCase();

  relationshipRoles.forEach(({ keyword, aliases, role }) => {
    const allTerms = [keyword, ...aliases];

    allTerms.forEach(term => {
      // 💬 Pattern 1: My daughter's name is X
      const possessivePattern = new RegExp(
        `\\bmy\\s+${term}(?:'s|s)?\\s+name(?:s)?\\s+(?:is|are|was|=)?\\s*([A-Z][a-zA-Z]*(?:\\s*(?:,\\s*|\\band\\b\\s*)[A-Z][a-zA-Z]*)*)`,
        'gi'
      );

      let match;
      while ((match = possessivePattern.exec(message)) !== null) {
        const names = match[1]
          .split(/\s*(?:,|(?:\band\b))\s*/)
          .map(name => name.trim())
          .filter(Boolean);

        names.forEach(name => {
          entities.push({ type: 'relationship', role, name });
        });
      }

      // 💬 Pattern 2: Marc and Anthony are my brothers
      const inversePattern = new RegExp(
        `([A-Z][a-zA-Z]*(?:\\s*(?:,\\s*|\\band\\b\\s*)[A-Z][a-zA-Z]*)*)\\s+(?:is|are)\\s+my\\s+${term}(?:'s|s)?`,
        'gi'
      );

      while ((match = inversePattern.exec(message)) !== null) {
        const names = match[1]
          .split(/\s*(?:,|(?:\band\b))\s*/)
          .map(name => name.trim())
          .filter(Boolean);

        names.forEach(name => {
          entities.push({ type: 'relationship', role, name });
        });
      }

      // 💬 Pattern 3: My brothers are Marc and Anthony
      const pluralIntroPattern = new RegExp(
        `\\bmy\\s+${term}s?\\s+(?:are|were)\\s+([A-Z][a-zA-Z]*(?:\\s*(?:,\\s*|\\band\\b\\s*)[A-Z][a-zA-Z]*)*)`,
        'gi'
      );

      while ((match = pluralIntroPattern.exec(message)) !== null) {
        const names = match[1]
          .split(/\s*(?:,|(?:\band\b))\s*/)
          .map(name => name.trim())
          .filter(Boolean);

        names.forEach(name => {
          entities.push({ type: 'relationship', role, name });
        });
      }
    });
  });

  return entities;
};




// 👇 THEN: Define buildContext
const buildContext = (message = '', reply = '', memories = []) => {
  const entities = extractEntities(message);
  console.log('🧪 Extracted entities:', entities);

  const context = {
    tone: 'neutral',
    mood: 'curious',
    urgency: 'normal',
    energy: 'medium',
    entities,
  };

  // 🧹 Filter out non-user-generated junk before using it
  const cleanMemories = memories.filter(mem =>
    mem.type !== 'injected' &&
    mem.origin !== 'search'
  );

  if (cleanMemories.length) {
    const recentMessages = cleanMemories.slice(0, 5).map(mem => mem.message).join(' ');
    context.shapedRecents = `Recently, the user has shared things like: ${recentMessages}`;
  }

  return context;
};


export default buildContext;
